import moment from "moment"
import { formatDate } from "../helpers/helpers"
import { tags } from "../mockData"

const TagsContent = ({isEvent, data, pageType}) => {
    return (
            <ul className='news__tags news__card-tags'>
                {data ? (
                    isEvent ? (
                        <>
                            {data.withMegamix && <li className='news__tag'>с участием мегамикс</li>}
                            <li className='news__tag'>{data.location}</li>
                            <li className='news__tag'>
                                {data.dateFrom?.toString() === data.dateTo?.toString()
                                    ? `${formatDate(data.dateFrom).toLowerCase()} ${moment(data.dateFrom).format(
                                          'YYYY'
                                      )}`
                                    : `${formatDate(data.dateFrom).toLowerCase()} — ${formatDate(
                                          data.dateTo
                                      ).toLowerCase()} ${moment(data.dateFrom).format('YYYY')}`}
                                {pageType === 'webinar' && data?.time ? data.time : null}
                            </li>
                        </>
                    ) : pageType === 'vacancy' ? (
                        <li className='news__tag'>{data?.region && data?.region[0]?.title}</li>
                    ) : data.tags_id ? (
                        data.tags_id?.map(tag => (
                            <li
                                key={tag.id}
                                className='news__tag'
                            >
                                {tag.title}
                            </li>
                        ))
                    ) : (
                        tags?.map((tag, index) => (
                            <li
                                key={tag}
                                className={index === tags.length - 1 ? 'news__tag news__tag-date' : 'news__tag'}
                            >
                                {tag}
                            </li>
                        ))
                    )
                ) : (
                    tags.map((tag, index) => (
                        <li
                            key={tag}
                            className={index === tags.length - 1 ? 'news__tag news__tag-date' : 'news__tag'}
                        >
                            {tag}
                        </li>
                    ))
                )}
                {!isEvent && (
                    <li className='news__tag-date'>
                        {data && (
                            <>
                                {data.creation_date?.split('T')[0].split('-')[2]}.
                                {data.creation_date?.split('T')[0].split('-')[1]}.
                                {data.creation_date?.split('T')[0].split('-')[0]}{' '}
                                {pageType === 'webinar' && data?.time ? data.time : null}
                            </>
                        )}
                    </li>
                )}
            </ul>
    )
}

export default TagsContent
